import StoreModuleService from '../StoreModuleService';
import { initialState } from './state';
import Vue from 'vue';

export const SET_INPUT_CONFIG = 'SET_INPUT_CONFIG';
export const SET_IS_UPDATING_SUBFLOW_PARAMS = 'SET_IS_UPDATING_SUBFLOW_PARAMS';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_INPUT_CONFIG](state, { id, params }) {
		const newSubflowParams = { ...state.subflowParams, [id]: params.sort((a, b) => a.id - b.id) };
		Vue.set(state, 'subflowParams', newSubflowParams);
	},
	[SET_IS_UPDATING_SUBFLOW_PARAMS](state, payload) {
		Vue.set(state, 'isUpdatingSubflowParams', payload);
	},
};

export default mutations;
